import { NuxtRuntimeConfig } from '@nuxt/types/config/runtime'

import { useCloudflareStore } from '~/store'
import { useCountry } from '~/composables/country/useCountry'
import { formatPrice } from '@/common/utils/numbers'
import { PLACEHOLDER_IMAGE_FILENAME, PRODUCT_STATUS } from '~/common/utils/product/constants'
import { MappedProduct } from '~/types/product/productTypes'
import { mapChicletsForApplicationTab } from '~/common/utils/product/product'

export function buildRelatedProduct(props: { product: MappedProduct; config: NuxtRuntimeConfig }) {
  return {
    name: props.product.name,
    productId: props.product.id,
    productUrl: props.product.attributes.sefUrl,
    productType: props.product.productType,
    imageUrl: (() => {
      let url = `/${PLACEHOLDER_IMAGE_FILENAME}`
      const image = props.product.attributes.images[0]
      if (image?.filename) {
        if (image.filename === PLACEHOLDER_IMAGE_FILENAME) {
          return url
        }
        url = `${props.config.cst.mediaUrl}/product/image/${image.filename}`

        if (
          useCloudflareStore().images[image['dam-media-id']] &&
          useCloudflareStore().images[image['dam-media-id']].variants.PUBLIC
        ) {
          url = useCloudflareStore().images[image['dam-media-id']].variants.PUBLIC
        }
      }
      return url
    })(),
    imagesData: props.product.attributes.images.map((image) => {
      return { ...image, cloudflare: useCloudflareStore().images[image['dam-media-id']] }
    }),
    price: (() => {
      if (Object.values(props.product.skuData)[0]?.priceForCurrentCountry) {
        if (useCountry().isUS.value) {
          return formatPrice(
            Object.values(props.product.skuData)[0].priceForCurrentCountry.centAmount,
            Object.values(props.product.skuData)[0].priceForCurrentCountry.currencyCode,
            Object.values(props.product.skuData)[0].priceForCurrentCountry.fractionDigits
          )
        }
      }
    })(),
    size: (() => {
      if (Object.values(props.product.skuData)[0]?.attributes) {
        return (
          Object.values(props.product.skuData)[0].attributes.amount +
          ' ' +
          Object.values(props.product.skuData)[0].attributes.uom
        )
      }
    })(),
    modalTitleData: {
      key: props.product.id,
      name: props.product.name,
      isProductDiscontinued: props.product.attributes.statusDates?.status === PRODUCT_STATUS.DISCONTINUED,
    },
    applicationChiclets: mapChicletsForApplicationTab(props.product),
  }
}
